<div>
    <div #chartTarget></div>
</div>
<div *ngIf="showTable && componentName === 'production-by-street'">
    <app-production-by-street-table
        [collection]="dataProd"
    ></app-production-by-street-table>
</div>
